import Moment from 'moment'; // eslint-disable-next-line arrow-body-style

export var getInputValue = function getInputValue(date, format) {
  return date ? Moment(date).format(format) : '';
};
export default getInputValue;